import { BaseProvider, MetaMaskInpageProvider } from '@metamask/providers';
import isElement from 'lodash.iselement';

declare global {
  interface Window {
    ethereum?:
      | (BaseProvider &
          Partial<MetaMaskInpageProvider> & {
            isTrust: boolean;
          })
      | null;
    safepalProvider: BaseProvider | null;
    okxwallet: BaseProvider | null;
  }
}

// If Safari, if window.ethereum not present, window.ethereum is Element!!!
export const ethereum =
  typeof window.ethereum === 'object' &&
  !isElement(window.ethereum) &&
  window.ethereum !== null
    ? window.ethereum
    : undefined;

// If Safari, if window.safepalProvider not present, window.safepalProvider is Element
export const safepal =
  typeof window.safepalProvider === 'object' &&
  !isElement(window.safepalProvider) &&
  window.safepalProvider !== null
    ? window.safepalProvider
    : undefined;

// If Safari, if window.okxwallet not present, window.okxwallet is Element
export const okx =
  typeof window.okxwallet === 'object' &&
  !isElement(window.okxwallet) &&
  window.okxwallet !== null
    ? window.okxwallet
    : undefined;
